module.exports = __webpack_public_path__ + "officialStatic/img/soft27.13ea469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft27.png
// module id = dgf3
// module chunks = 0